const module = 'admin'
const app = 'erf'

export default {
  'api:admin:erf:erftype:list': `/${module}/${app}/erf-types`,
  'api:admin:erf:erftype:detail': `/${module}/${app}/erf-types/:id`,

  'api:admin:erf:erfmapping:list': `/${module}/${app}/erf-mappings`,
  'api:admin:erf:erfmapping:detail': `/${module}/${app}/erf-mappings/:id`,
}